import { useCallback } from 'react';
import SearchInput from 'components/SearchInput';
import { useTurnaroundListFilters } from '../hooks/useTurnaroundListFilters';

export const TurnaroundListSearch = () => {
  const [turnaroundListFilters, setTurnaroundListFilters] = useTurnaroundListFilters();

  const onChange = useCallback(
    (value: string) => {
      // If the value is empty, delete the search filter
      const newFilters = { ...turnaroundListFilters };

      if (!value) {
        delete newFilters.search;
      } else {
        newFilters.search = value;
      }

      setTurnaroundListFilters(newFilters);
    },
    [setTurnaroundListFilters, turnaroundListFilters],
  );

  return <SearchInput value={turnaroundListFilters.search} onChange={onChange} />;
};
